import * as ACTIONS from "./../actions/types"

// A reducer to hold data about the devices

const defaultState = {
  condition: -1
}

const conditionReducer = (state = defaultState, { type, payload }) => {
  switch (type) {
    case ACTIONS.SELECT_CONDITION:
      return { ...state, condition: payload }

    case ACTIONS.SET_STORENAME:
      return { ...state, storeName: payload }

    default:
      return state
  }
}

export default conditionReducer
